import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import firebaseConfig from './config'

import axios from 'axios';

const mainApp = firebase.initializeApp(firebaseConfig)

class AuthServiceClass {
  authInstance = firebase.auth(mainApp);
  authMethod = firebase.auth;

  AuthService() {
    this.authInstance.useDeviceLanguage();
  }

  async getUser() {
    const user = await this.authInstance.currentUser;
    if (user) {
      return user;
    }
  }

  async SignUpWithEmailAndPassword({ email, password }) {
    let error, user;

    try {
      user = await this.authInstance.createUserWithEmailAndPassword(email, password);
      return { user, error: null };

    } catch (e) {
      switch (e.code) {
        case 'auth/email-already-in-use':
          error = 'The email address is already in use by another account.';
          break;
        case 'auth/invalid-email':
          error = 'The email address is badly formatted.';
          break;
        case 'auth/weak-password':
          error = 'The password must be at least 6 characters long.';
          break;
        case 'auth/network-request-failed':
          error = 'A network error occurred. Please check your internet connection and try again.';
          break;
      }
      return { user, error };
    }
  }

  async SignInWithEmailAndPassword({ email, password }) {
    let error, user;

    try {
      user = await this.authInstance.signInWithEmailAndPassword(email, password);
      return { user, error: null };

    } catch (e) {
      switch (e.code) {
        case 'auth/invalid-email':
          error = 'Invalid email address format. Please enter a valid email address.';
          break;
        case 'auth/user-disabled':
          error = 'This account has been disabled. Please contact support for assistance.';
          break;
        case 'auth/user-not-found':
          error = 'Invalid email. Please check your credentials and try again.';
          break;
        case 'auth/wrong-password':
          error = 'Invalid password. Please check your credentials and try again.';
          break;
        case 'auth/network-request-failed':
          error = 'A network error occurred. Please check your internet connection and try again.';
          break;
      }
      return { user, error };
    }
  }



  // TO DO, implement this
  async authWithGoogle() {
    var provider = this.authMethod.GoogleAuthProvider;

    let firebaseError;
    let user;
    try {
      const result = await this.authInstance.signInWithPopup(provider);
      // This gives you a Google Access Token. You can use it to access the Google API.
      // var token = result.credential.accessToken;
      // // The signed-in user info.
      user = result.user;
    } catch (error) {
      // var errorCode = error.code;
      // var errorMessage = error.message;
      // The email of the user's account used.
      // var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      // var credential = error.credential;
      firebaseError = error;
    };

    return { user, firebaseError };
  }

  async AskOTPCode(phoneNumber, appVerifier, getCodeForLink) {
    let confirmationResult;
    let error;

    try {
      confirmationResult = await this.authInstance.signInWithPhoneNumber(phoneNumber, appVerifier);
      const code = await getCodeForLink();
      const credential = this.authMethod.PhoneAuthProvider.credential(confirmationResult.verificationId, code);
      await this.authInstance.currentUser.linkWithCredential(credential);

      return { confirmationResult, error };

    } catch (e) {
      console.log('e.code', e.code)
      switch (e.code) {
        case 'auth/invalid-phone-number':
          error = 'Invalid phone number. Please enter a valid phone number.';
          break;
        case 'auth/missing-phone-number':
          error = 'Phone number is required.';
          break;
        case 'auth/code-expired':
          error = 'The SMS code has expired. Please request a new one.';
          break;
        case 'auth/code-invalid':
          error = 'Invalid SMS code. Please enter the correct code.';
          break;
        case 'auth/credential-already-in-use':
          error = 'The phone number is already linked to another account.';
          break;
        case 'auth/provider-already-linked':
          error = 'Phone number not verified';
          break;
        case 'auth/invalid-app-credential':
          error = 'The app verification credential is invalid or has expired. Please try again.';
          break;
        default:
          error = 'An unknown error occurred. Please try again.';
          break;
      }
      return { confirmationResult, error };
    }


  }

  async signOut() {
    const error = await this.authInstance.signOut();

    return { error };
  }

  authPersistence(setUser) {
    this.authInstance.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
    this.authInstance.onAuthStateChanged(async (user) => {
      if (user) {
        if (user.uid && user.uid !== 'none') {
          try {
            await axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'UpdateUserbyId', id: user.uid, email: user.email })
              .then(response => {
                console.log('response', response)
                const user2 = {
                  uid: user.uid,
                  email: user.email,
                  phoneNumber: user.phoneNumber,
                  role: response.data.data.role ? response.data.data.role : 'user',
                  profile_complete: response.data.data.profile_complete ? response.data.data.profile_complete : false,
                  userType: response.data.data.userType ? response.data.data.userType : '',
                };
                setUser(user2);
              })
              .catch(error => {
                console.error('Error fetching data:', error);
              });

          } catch (error) {
            console.error("Error fetching user document:", error);
          }
        } else {
          setUser({ uid: 'none', email: '', phoneNumber: '', role: '' });
        }
      } else {
        setUser({ uid: 'none', email: '', phoneNumber: '', role: '' });
      }
    });
  }

  changeEmail = async (currentPassword, newEmail) => {
    var user = await this.getUser();
    console.log(user, newEmail, currentPassword);
    const credential = this.authMethod.EmailAuthProvider.credential(user.email, currentPassword);
    user.reauthenticateWithCredential(credential).then(() => {
      user.updateEmail(newEmail).then(() => {
        console.log("Email updated!");
      }).catch((error) => { console.log(error); });
    }).catch((error) => { console.log(error); });
  }

  changePassword = async (currentPassword, newPassword) => {
    try {
      let tyret;
      const user = await this.getUser();
      console.log(user, currentPassword);
      const credential = this.authMethod.EmailAuthProvider.credential(user.email, currentPassword);
      await user.reauthenticateWithCredential(credential);
      await user.updatePassword(newPassword);
      tyret = true;
      return tyret;
    } catch (error) {
      let errorMessage;
      switch (error.code) {
        case "auth/wrong-password":
          errorMessage = "Current password is incorrect.";
          break;
        case "auth/too-many-requests":
          errorMessage = "Too many attempts. Please try again later.";
          break;
        case "auth/weak-password":
          errorMessage = "The new password must be at least 6 characters long.";
          break;
        case "auth/user-mismatch":
          errorMessage = "User mismatch. Please log in again.";
          break;
        case "auth/requires-recent-login":
          errorMessage = "This operation is sensitive and requires recent login. Please sign in again.";
          break;
        default:
          errorMessage = "An unknown error occurred. Please try again.";
      }
      console.error("Error changing password:", error);
      return { success: false, message: errorMessage };
    }
  }


  changeEmailAdmin = async (currentPassword, newEmail) => {
    var user = await this.getUser();
    console.log(user, newEmail, currentPassword);
    const credential = this.authMethod.EmailAuthProvider.credential(user.email, currentPassword);
    user.reauthenticateWithCredential(credential).then(() => {
      user.updateEmail(newEmail).then(() => {
        return true;
      }).catch((error) => { return error; });
    }).catch((error) => { return error; });
  }


  changePasswordAdmin = async (currentPassword, newPassword) => {
    try {
      const user = await this.getUser();
      console.log(user, currentPassword);
      const credential = this.authMethod.EmailAuthProvider.credential(user.email, currentPassword);

      await user.reauthenticateWithCredential(credential);
      await user.updatePassword(newPassword);

      return true;
    } catch (error) {
      return error;
    }
  }


  resetPassword = async (emailAddress) => {
    try {
      await this.authInstance.sendPasswordResetEmail(emailAddress);
      return true;
    } catch (error) {
      // An error happened.
      return error;
    };
  }
};


class FireStoreServiceClass {
  Firestore = firebase.firestore();
  FireStoreMethod = firebase.firestore;

  FireStoreService() {
    this.Firestore.settings({ timestampsInSnapshots: true })
  }

  async getQuery(collection, query) {
    try {
      const querySnapshot = await this.Firestore.collection(collection).where(query[0], query[1], query[2]).get();
      let docs = {};
      querySnapshot.forEach((doc) => {
        docs[doc.id] = doc.data();
      })
      return docs;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

}


export const AuthService = new AuthServiceClass();
export const FireStoreService = new FireStoreServiceClass();